export default {"src":"/_next/static/media/ic_arrow_drop_down.a7249683.svg","height":5,"width":10,"blurWidth":0,"blurHeight":0};